import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

const StyledContainer = styled(Container)`
  padding-top: 10px;
`

const Wrapper = styled.div`
  margin-bottom: 100px;
  position: relative;
  overflow: visible;
  width: 95%;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};

  ${media.xs`
    margin-bottom: 135px;
    width: 100%;
  `}

  svg {
    transition: transform 0.3s ${easing.easeOutCubic};
  }

  &:hover {
    svg {
      transform: translateX(25%);
    }
  }
`

const Image = styled.div`
  background: url(${props => props.image}) center / cover;
  width: 100%;
  height: 0;
  padding-top: 58.333%;
  position: relative;
  z-index: 3;

  ${media.xs`
    width: 100%;
    padding-top: calc(100% - 60px);
  `}
`

const TextContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  width: 90%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media.lg`
    width: 80%;
  `}

  ${media.xs`
    position: relative;
    width: 100%;
  `}
`

const Text = styled.h4`
  font-size: 22px;
  margin: 0 0 0 20px;

  ${media.lg`
    font-size: 25px;
  `}

  ${media.xs`
    font-size: 20px;
  `}
`

const ArrowContainer = styled.div`
  background-color: ${props => props.theme.colors[props.color].base};
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

const WhiteFill = styled.div`
  position: absolute;
  right: 0;
  top: -20px;
  background: white;
  height: calc(100% - 60px);
  width: 92%;
  z-index: 1;

  ${media.xs`
    height: calc(100% + 30px);
    right: -20px;
  `}
`

const Brush = styled.div`
  position: absolute;
  top: -10%;
  right: -5%;
  background: url(${props => props.theme.colors[props.color].brush2}) right center / cover no-repeat;
  height: 0;
  width: 50%;
  padding-top: 17%;
  z-index: 2;

  ${media.xs`
    top: -15%;
    right: -3%;
  `}
`

export default class Grid extends Component {
  render() {
    const { boxes } = this.props
    
    return(
      <StyledContainer fluid>
        <Row>
          {boxes.map((box, index) => {
            return(
              <Col
                md={6}
                key={index}
              >
                <Link to={getRelativeUrl(box.link)}>
                  <InViewMonitor childPropsInView={{inView: true}}>
                    <Wrapper>
                      <Image image={box.image.sourceUrl}>
                        <TextContainer>
                          <Text>{box.text}</Text>
                          <ArrowContainer color={box.color}>
                            <svg
                              width="18"
                              height="15"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="#FFF"
                                fillRule="evenodd"
                                d="M10.5610474 14.812003c-.1539376.1484976-.2731487.187997-.4680326.187997h-.8352535c-.349599 0-.4294185-.2414961-.194625-.4679922l6.6330485-6.3986434H.3887311C.1360559 8.1333644 0 8.0021166 0 7.7583707v-.5167414c0-.2437459.1360559-.3749937.3887311-.3749937h15.3074537L9.0631363.4679922C8.8283428.2414961 8.9081623 0 9.2580203 0h.8352535c.194884 0 .3311989.0562491.4677732.187997l7.3073674 7.0491326c.1754475.1692473.1754475.3564943 0 .5257416l-7.3073674 7.0491326 4e-7-8e-7z"
                              />
                            </svg>
                          </ArrowContainer>
                        </TextContainer>
                      </Image>
                      <Brush color={box.color} />
                      <WhiteFill />
                    </Wrapper>
                  </InViewMonitor>
                </Link>
              </Col>
            )
          })}
        </Row>
      </StyledContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Grid/index.js